import DOMPurify from 'isomorphic-dompurify'

/**
 * @link: https://github.com/cure53/DOMPurify/blob/main/README.md
 */
export const sanitize = DOMPurify.sanitize
// allow all safe HTML elements but neither SVG nor MathML
// note that the USE_PROFILES setting will override the ALLOWED_TAGS setting
// so don't use them together
export function stripHtml(source: string | Node,
  isHtml: boolean | undefined = true, defaultValue: string | undefined = '') {
  return source ? sanitize(source, { USE_PROFILES: { html: isHtml } }) : defaultValue
}

// allow only <b> and <q> with style attributes
export function limitHtml(source: string | Node, tags: string[] = []) {
  return DOMPurify.sanitize(source, { ALLOWED_TAGS: tags, ALLOWED_ATTR: [] })
}
